module.exports = __webpack_public_path__ + "img/boqinspect3_7-8-2021.a0032783.jpg";